import React from 'react';

export default function GapAnalysisTab({ gapEntries, maxGap }) {
  return (
    <>
      <p className="section-label">Top 25 numbers by gap — draws since last appearance</p>
      <table className="gap-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Last seen</th>
            <th>vs. avg gap</th>
            <th>Gap</th>
          </tr>
        </thead>
        <tbody>
          {gapEntries.map(({ n, g }) => (
            <tr key={n}>
              <td style={{ fontWeight: 700 }}>{n}</td>
              <td>{g} draws ago</td>
              <td style={{ color: g > 20 ? 'var(--color-mark-hot)' : 'var(--text-muted)' }}>{g > 20 ? 'Above avg' : 'Normal'}</td>
              <td>
                <span
                  className="gap-bar"
                  style={{ width: `${Math.round((g / maxGap) * 100)}px` }}
                ></span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="section-note">
        A large gap is a historical observation only. Lottery draws are memoryless — each draw is an independent random event and a number is never statistically "due."
      </p>
    </>
  );
}
